import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React, {Suspense} from "react"; //eslint-disable-line

import { useEffect } from "react";
import CookieConsent, {
  getCookieConsentValue,
  Cookies,
} from "react-cookie-consent";
import { initGA } from "./ga-util.js";
import { BrowserRouter as Router, Switch, Route  } from "react-router-dom";

// import Contacts  from "demos/Contacts.js";
// import About  from "demos/About.js";
// import Services  from "demos/Services.js";
// import MainLandingPage  from "demos/MainPage.js";
const MainLandingPage = React.lazy(() => import('pages/MainPage.js'));
const About = React.lazy(() => import('pages/About.js'));
const Services = React.lazy(() => import('pages/Services.js'));
const Contacts = React.lazy(() => import('pages/Contacts.js'));



export default function App() {
  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;
  const handleAcceptCookie = () => {
      initGA('UA-197767993-1');
  };

  const handleDeclineCookie = () => {
    //remove google analytics cookies
    Cookies.remove("_ga");
    Cookies.remove("_gat");
    Cookies.remove("_gid");
  };

  useEffect(() => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true") {
      handleAcceptCookie();
    }
    else{
      handleDeclineCookie();
    }
  });



  return (
    <Router>
      <Suspense fallback="Loading...">
      <Switch>
          <Route path="/services">
            <Services />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/contacts">
            <Contacts />
          </Route>
          <Route path="/">
            <CookieConsent
            //enableDeclineButton
            onAccept={handleAcceptCookie}
            //onDecline={handleDeclineCookie}
            location="bottom"
            flipButtons
            buttonText={'Приемам'}
            style={{background: '#fff',"text-align": "center", 
            color: "black","border": "1px solid black",
            borderRadius: "10px",
            "display":"inline-block",
            "box-sizing":"border-box",
            "float":"right",
            "max-width": "80%",
            "margin-left":"10%",
            "margin-right": "50px",
            "margin-bottom":"1%",
            "margin-top":"10px",
            "line-height":"20px",
            "boxShadow":"0px 0px 3px  black",
            }}
            buttonStyle={{ background: '#ed8936', borderRadius: "10px",
            display: "inline-block",
            color: "#fff", fontSize: "16px", padding:"8px 40px"  }}
            expires={150}

            // buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            >
            Сайта използва „бисквитки" за подобряване на преживяването.{" "}
            </CookieConsent>
            
            <MainLandingPage />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}

